// @flow

import { crmCallActions } from './crmCallingActionCreator';

const initialState = {
  supersetCall: false,
  waitForForm: false,
  displayErrorMessage: null,
  uuid: null,
  formSrc: null,
  apiData: null,
  showCallReasonsModal: false,
  callInitiated: false
};

const crmCallingReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case crmCallActions.CRM_CALLING: {
      return Object.assign({}, state, action.payload);
    }
    default: {
      return state;
    }
  }
};

export default crmCallingReducer;
